import { useAuth } from '../auth/AuthContext';

export function AccessDeniedPage() {
  const { signOut } = useAuth();
  return <div className="public-wrap"><section className="public-card">
    <div className="public-brand">Flowcount</div>
    <h1>Access denied</h1>
    <p>You are signed in with Google, but this account is not set up to use Flowcount.</p>
    <p>If you should have access, ask the person who manages Flowcount users to add this email.</p>
    <button className="primary wide" onClick={() => void signOut()}>Try another account</button>
  </section></div>;
}
